module.exports = __webpack_public_path__ + "img/bg-768@2x.e7481b1d.png";